import React, { Component } from 'react';

class ShareButton extends Component {

  constructor() {
    super();

    this.content = {
      fbImage: process.env.REACT_APP_IMAGES_ROOT + 'facebook-2.svg',
      twImage: process.env.REACT_APP_IMAGES_ROOT + 'twitter-2.svg',
      ogImage: process.env.REACT_APP_IMAGES_ROOT + 'og-image.jgp',
      shareText: 'Visit Dermalogica Sound Sleep App, featuring a 20-minute sleep sound, DIY facial massage, and restorative sleep tips. Use with NEW Sound Sleep Cocoon moisturizer for a truly transformative experience.'
    }
    this.triggerFacebook = this.triggerFacebook.bind(this);
    this.triggerTwitter  = this.triggerTwitter.bind(this);
    this.openShareWindow = this.openShareWindow.bind(this);

  }

  componentDidMount() {
    setTimeout( () => {
      this.setState({mounted: true});
    }, 25);
  }

  openShareWindow(url){
    <script>
      function shareOverrideOGMeta()
      {

      }
    </script>
    let leftPosition, topPosition, width, height;
        width        = 606;
        height       = 305;
        leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
        topPosition  = (window.screen.height / 2) - ((height / 2) + 50);
    const windowFeatures = "status=no,height=" + height +
                         ",width=" + width +
                         ",resizable=no,left=" + leftPosition +
                         ",top=" + topPosition +
                         ",screenX=" + leftPosition +
                         ",screenY=" + topPosition +
                         ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
    window.open(url, 'dermalogica-soundsleepcocoon-sharer', windowFeatures);
  };

  triggerFacebook(e){
    // const self = this;
    const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(process.env.REACT_APP_PUBLIC_URL);
    console.log(url);
    this.openShareWindow(url);
  }

  triggerTwitter(e) {
   e.preventDefault()
    let url = 'https://twitter.com/intent/tweet';
    url += '?text=' + encodeURIComponent(this.content.shareText);
    url += '&url=' + encodeURIComponent(process.env.REACT_APP_PUBLIC_URL);
    url += '&image=' + encodeURIComponent(this.content.ogImage);
    this.openShareWindow(url);
  }

  render() {
    const divStyle = {
      display: 'block',
      clear: 'both',
      width: '100%',
      margin: 'auto'
    }

    const facebookStyle = {
      position: 'relative',
      display: 'inline-block',
      whiteSpace: 'nowrap',
      padding: '3px 10px 10px 10px',
      marginTop: '0.50em',
      marginRight: '0.50em',
      cursor: 'pointer'
    };

    const twitterStyle = {
      position: 'relative',
      display: 'inline-block',
      whiteSpace: 'nowrap',
      padding: '3px 10px 10px 10px',
      marginTop: '0.50em',
      marginLeft: '0.50em',
      cursor: 'pointer'
    };

    const fbSpanStyle = {
      position:'relative',
      top: '3px'
    }

    const twSpanStyle = {
      position:'relative',
      top: '3px'
    }

    const fbImageStyle = {
      width: '30px',
      position:'relative',
      top: '9px',
      marginRight: '6px'
    }

    const twImageStyle = {
      width: '30px',
      position:'relative',
      top: '9px',
      marginRight: '6px'
    }


    return (
      <div style={divStyle}>
      	<div style={facebookStyle} onClick={this.triggerFacebook}>
          <img src={this.content.fbImage} style={fbImageStyle} alt="facebook"/>
          <span style={fbSpanStyle}>Share</span>
        </div>
      	<div style={twitterStyle} onClick={this.triggerTwitter}>
          <img src={this.content.twImage} style={twImageStyle} alt="twitter"/>
          <span style={twSpanStyle}>Tweet</span>
        </div>
      </div>
    );
  }
}

export default ShareButton;


// WEBPACK FOOTER //
// ./src/components/ShareButton/ShareButton.js